export function formatSpecsInheritedPlaceholder(value: string | undefined) {
  if (!value?.startsWith("specs.")) {
    return value;
  }

  return `valeur héritée de: ${value}`;
}
